export function Card({ message, card, size }: { message: string; card: string; size: 'sm' | 'lg' }) {
  const scale = size === 'sm' ? 1 : 2;

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: size === 'lg' ? 24 : 12,
        lineHeight: 1.25,
        fontWeight: 500,
        textAlign: 'center',
      }}
    >
      {/* Left Card Image */}
      <img src={`/img/happy-grams/${card}-left.png`} width={200 * scale} height={280 * scale} />

      {/* Right side with background image and message */}
      <div
        style={{
          width: 200 * scale,
          height: 280 * scale,
          backgroundImage: `url(/img/happy-grams/holiday-card-warm-sparkle-right.png)`,
          backgroundSize: `${100 * scale}% ${100 * scale}%`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative', // Added to position the message absolutely
        }}
      >
        <div
          style={{
            position: 'absolute', // Position absolutely within the parent
            inset: 0, // Spread to fill the parent
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24 * scale, // Add padding to prevent text from touching edges
          }}
        >
          <div
            style={{
              maxWidth: 152 * scale,
            }}
          >
            {message}
          </div>
        </div>
      </div>
    </div>
  );
}
